import styled from '@emotion/styled';
import tw from 'twin.macro';

export const StyledLanguagesGridBlockV3Section = styled.section`
  ${tw`bg-neutrals-n1`}
  ${tw`px-2 md:px-0`}
  ${tw`container`}
  ${tw`flex justify-center`}
`;

export const StyledContainer = styled.div`
  ${tw`flex flex-wrap justify-center`}
  ${tw`gap-[16px] md:gap-[23px] lg:gap-[30px]`}
  ${tw`max-w-[930px] w-full`}
`;
